import React from 'react'
import type { ComponentProps, PartData } from '@enonic/react-components'

import VideoPrototype from '/react4xp/components/prototype/Video'
import { EditorPlaceholder } from '/react4xp/components/shared/EditorPlaceholder'

type VideoPartData = {
	videoUrl?: string
	youtubeVideoId?: string
	thumbnail?: { src: string; alt: string }
	playLabel?: string
	// Emitted by the processor only when nothing is playable.
	youtubeInputPresent?: boolean
}

export const Video = ({ meta, data }: ComponentProps<PartData>) => {
	const { videoUrl, youtubeVideoId, thumbnail, playLabel, youtubeInputPresent } = (data || {}) as VideoPartData

	if (!videoUrl && !youtubeVideoId) {
		return (
			<EditorPlaceholder
				mode={meta?.mode}
				componentClass="video-player"
				title="Video"
				reason={
					youtubeInputPresent
						? 'That YouTube value is not a recognisable video ID or URL.'
						: 'No YouTube video and no uploaded video selected.'
				}
			/>
		)
	}

	return (
		<VideoPrototype
			// Encoded because the prototype interpolates this straight into the embed URL: a pasted
			// `ID?autoplay=1` would otherwise rewrite the query and autoplay the video on load.
			videoId={youtubeVideoId ? encodeURIComponent(youtubeVideoId) : undefined}
			videoUpload={videoUrl ? { src: videoUrl } : undefined}
			thumbnail={thumbnail}
			playLabel={playLabel}
			isPart
		/>
	)
}
